export default "__VITE_ASSET__CC7nSsf3__"